import DateFormat from '../../helpers/DateFormat'
import { FormattedMessage } from 'react-intl'
import PriceConverter from '../../helpers/PriceConverter'
import moment from 'moment'
import get from 'lodash/get'
import {
  ActivityDuration,
  ActivityDives,
} from '../CardsDsl/AdventureCardInclusions'

import styles from './scheduleDates.module.scss'
import cx from 'classnames'
import InstantConfirmation from '../../adventures/InstantConfirmation'
import { pushToDataLayer } from '../../../gtm'
import { getProductCategory } from '../../dive-guides/gtm-events'
import { target } from '../../../utils'

// import DiveSitesList from '../../adventures/DiveSitesList'
// const messages = defineMessages({
//   advancedDivers: {
//     id: 'advanced_only',
//     defaultMessage: 'Advanced divers only',
//   },
//   advanced: {
//     id: 'advanced',
//     defaultMessage: 'Advanced',
//   },
// })

// const AdvancedDiver = ({ text }) => {
//   return (
//     <span className={cx(styles.diveSiteInfo, styles.advancedDivers)}>
//       <i className={cx(styles.fontIcons, 'font-icons icon-warning')} />
//       <span className={styles.diveSiteText}>
//         <FormattedMessage {...text} />
//       </span>
//     </span>
//   )
// }
//
// const DiveSites = ({ sites }) => {
//   const dsLength = get(sites, 'length')
//   if(!dsLength) {
//     return null
//   }
//   return (
//     <span className={styles.diveSiteInfo}>
//       <i className={cx(styles.fontIcons, 'font-icons icon-dive-sites')} />
//       <span>
//         <DiveSitesList sites={sites} />
//       </span>
//     </span>
//   )
// }

const ActivitySchedule = ({ item }) => {
  const startTime = moment(`1970-01-01T${item.startTime}`)
  const endTime = moment(`1970-01-01T${item.startTime}`).add(
    item.durationHours,
    'hours'
  )
  const dateDifference = endTime.diff(startTime, 'days')
  return (
    <div className={cx(styles.inclusion, styles.time)}>
      <i className={cx(styles.dslIcons, 'dsl-icons dsl-icons--clock')} />
      <span>{startTime.format('HH:mm')}</span>
      {dateDifference ? (
        <span>
          &nbsp;
          <FormattedMessage id='start' defaultMessage='start' />
        </span>
      ) : (
        <span>-&nbsp;{endTime.format('HH:mm')}</span>
      )}
    </div>
  )
}

const Divider = () => <span className={styles.delimeter}>|</span>

const ScheduleDiveInfo = ({ item }) => {
  return (
    <div className={styles.activityTitle}>
      <span className={styles.tripTitle}>{item.title}</span>
      <div className={cx(styles.trip, styles.inclusions)}>
        <ActivitySchedule item={item} />
        <Divider />
        <ActivityDuration item={item} />
        <Divider />
        <ActivityDives item={item} />
      </div>
      <div className={styles.badges}>
        <div className={styles.badge}>
          {item.activityType.replace('_', ' ')}
        </div>
      </div>
    </div>
  )
}

const ScheduleDivePrice = ({ item }) => {
  const price = get(item, 'minimumPrice.targetValue')
  const currency = get(item, 'minimumPrice.targetCurrency')
  return (
    <div className={styles.price}>
      <span className={styles.from}>
        <FormattedMessage id='from' defaultMessage='From' />
      </span>
      <span className={styles.pricing}>
        {item.instantConfirmation && <InstantConfirmation />}
        &nbsp;
        <PriceConverter amount={price} currency={currency} to={currency} />
      </span>
    </div>
  )
}

const Row = ({ item, searchPageSchedule, position }) => {
  const onClick = () => {
    pushToDataLayer({
      event: 'interaction',
      eventCategory: 'Dive Shop',
      eventAction:
        item.activityType === 'course'
          ? 'PADI - eLearning Click'
          : 'PADI - PADI Travel Click (Listing)',
      eventLabel: window.shopInfo.affiliateId,
      eventValue: '0',
      eventNonInteraction: 'false',
    })
    const activityCategory = getProductCategory(item.activityType).activityType
    pushToDataLayer({
      event: 'productClick',
      eventCategory: 'Dive Shop',
      eventAction: 'PADI - Activity Click',
      eventLabel: `${activityCategory} - ${item.title} - ${window.shopInfo.affiliateId}`,
      ecommerce: {
        currencyCode: get(item, 'minimumPrice.targetCurrency'),
        click: {
          products: [
            {
              name: item.title,
              id: item.id || item.activityId,
              price: get(item, 'minimumPrice.targetValue'),
              brand: 'PADI',
              category: activityCategory,
              position,
            },
          ],
        },
      },
    })
    window.open(
      `${item.activityPage}${window.isWidget ? '&widget=true' : ''}`,
      window.isWidget ? '_self' : target
    )
  }

  return (
    <div
      className={cx(styles.scheduleRow, {
        [styles.searchPageSchedule]: searchPageSchedule,
      })}
      onClick={onClick}
    >
      <ScheduleDiveInfo item={item} />
      <ScheduleDivePrice item={item} />
    </div>
  )
}

export default function ScheduleDatesDSL({
  items,
  date,
  searchPageSchedule,
  offset,
}) {
  return (
    <div className={styles.scheduleDates}>
      <div className={styles.header}>
        <span className={styles.date}>
          <DateFormat date={date} />
        </span>
      </div>
      {items.map(
        (item, index) =>
          item.activityType && (
            <Row
              item={item}
              position={offset + index + 1}
              key={item.id || item.activityId}
              searchPageSchedule={searchPageSchedule}
            />
          )
      )}
    </div>
  )
}
